export default __webpack_public_path__ + "static/media/mini-blog-desktop.789fd8f6.png";